// The soft hint under an item's department in Echipament nou and Editează: any department may be chosen, but
// when the responsible person is not a member there the item counts under their main department
// (pickers.notMemberHint, same text as the server). The person's departments come from GET /users/:id.
// The component defines the computed `hintOwnerId`, `hintDepartmentId` and `hintActive` (the dialog is open);
// memberships are asked again at every opening, since they can change in Utilizatori meanwhile.
import { getUserById } from "@/views/users/api";
import { notMemberHint } from "./pickers";

export default {
  data() {
    return {
      memberships: [],
      membershipsFor: null,
      membershipsLoading: false,
      membershipsFailed: false,
    };
  },
  computed: {
    departmentHint() {
      const ownerId = this.hintOwnerId;
      if (!ownerId || this.membershipsFor !== ownerId || this.membershipsFailed || !this.hintDepartmentId) return "";
      return notMemberHint(this.departments, this.memberships, this.hintDepartmentId);
    },
  },
  watch: {
    hintOwnerId() {
      this.loadMemberships();
    },
    hintActive(open) {
      if (open) this.loadMemberships();
      else this.forgetMemberships();
    },
  },
  methods: {
    async loadMemberships() {
      const ownerId = this.hintOwnerId;
      if (!ownerId || !this.hintActive) return;
      if (this.membershipsFor === ownerId && !this.membershipsFailed) return;
      this.membershipsLoading = true;
      this.membershipsFailed = false;
      try {
        const user = await getUserById(ownerId);
        if (this.hintOwnerId !== ownerId) return;
        this.memberships = Array.isArray(user.departments) ? user.departments : [];
        this.membershipsFor = ownerId;
      } catch (error) {
        // no hint then: it is only advice, saving works either way
        if (this.hintOwnerId !== ownerId) return;
        this.membershipsFor = ownerId;
        this.membershipsFailed = true;
      } finally {
        if (this.hintOwnerId === ownerId) this.membershipsLoading = false;
      }
    },
    forgetMemberships() {
      this.memberships = [];
      this.membershipsFor = null;
      this.membershipsFailed = false;
    },
  },
};
